import React from 'react';
import { useStore } from '@nanostores/react';
import { InputWidget } from '../../controls/widgets.jsx';
import NavBtnWidget from '../NavBtnWidget.jsx';
import moment from 'moment';


export default ({schema, data, onDataChanged}) => {
    const
        me = this,
        //
        onDataChangeEventHandler = (value, key) => {
            const diff = {};
            diff[key] = value;
            (onDataChanged || function(){})(diff);
        }
        ;
    return (
        <form className="form">
            <div className="card border-primary">
                <div className="card-header text-bg-primary">Согласие на обработку персональных данных</div>
                <div className="card-body">
                    <p className="text-justify">
                        Для продолжения необходимо подтвердить своё согласие на на сбор, хранение, обработку персональных данных
                        в автоматическом&nbsp;(информационными системами) и ручном режиме&nbsp;(ответственными специалистами) 
                        в соответствии с <a href="https://cdn.trit.biz/documents/loc-act/polozheniia/la-27-polozhenie-o-pd.pdf">положением об обработке персональных данных</a>
                        &nbsp;и&nbsp;
                        <a href="https://izhtrit.ru/politika-konfidencialnosti">политикой конфиденциальности</a>
                        &nbsp;в АПОУ&nbsp;УР&nbsp;&laquo;Техникум радиоэлектроники и информационных технологий
                        имени Александра Васильевича Воскресенского&raquo;.
                    </p>

                    <p className="text-justify">
                        Указанная в данной форме информация будет использована с целью исполнения Федерального
                        законодательства, регламентирующего порядок и условия организации обучения по программам подготовки
                        квалифицированных рабочих, служащих и специалистов среднего звена.
                    </p>

                    <p className="text-justify">
                        До момента отправки данные хранятся локально на устройстве пользователя
                        и не передаются в информационную систему техникума. В момент отправки
                        введённые вами данные передаются в информационную систему техникума по безопасному каналу связи.
                    </p>
                    <p className="text-justify">
                        В случае обрыва связи вы можете продолжить заполнение формы или очистить отправленные
                        данные нажав соответствующие кнопки.
                    </p>

                    <div className="row">
                        <div className="col-md-12">
                            <InputWidget
                                type="checkbox"
                                name="persdata_accepted"
                                title="Согласен на обработку персональных данных"
                                schema={schema}
                                data={data}
                                onChange={onDataChangeEventHandler}
                                />
                        </div>                        
                    </div>

                    {data['persdata_accepted_at']
                    ?<div className="row">
                        <div className="col-md-12">
                            <em>Согласие получено {moment(data['persdata_accepted_at']).format()}</em>
                        </div>
                    </div>
                    :null}

                </div>
            </div>

            {data['persdata_accepted']?<NavBtnWidget to="/start" />:null}
        
        </form>
    );
}